<div class="space-y-2">
  <div class="flex items-center gap-2">
    <label [attr.for]="id" class="text-sm font-semibold text-slate-900">
      {{ label() }}
    </label>
    <span
      class="inline-flex items-center gap-1 rounded-md bg-amber-100 px-2 py-0.5
             text-[10px] font-semibold uppercase tracking-wider text-amber-800"
    >
      <svg viewBox="0 0 16 16" class="size-3" fill="none" aria-hidden="true">
        <path d="M11.5 2.5a1.5 1.5 0 0 1 2 2L6 12l-3 1 1-3 7.5-7.5Z"
              stroke="currentColor" stroke-width="1.3" stroke-linejoin="round" />
      </svg>
      Manual Input
    </span>
  </div>

  <input
    [id]="id"
    [type]="type()"
    [formControl]="control()"
    [placeholder]="placeholder()"
    [attr.inputmode]="type() === 'number' ? 'decimal' : null"
    [attr.aria-invalid]="invalid()"
    class="h-11 w-full rounded-lg border bg-white px-4 text-[15px] text-slate-900
           placeholder:text-slate-400 focus:outline-none focus:ring-2
           focus:ring-indigo-500/30 [appearance:textfield]
           [&::-webkit-inner-spin-button]:appearance-none
           [&::-webkit-outer-spin-button]:appearance-none"
    [class]="invalid()
      ? 'border-red-400 focus:border-red-500'
      : 'border-slate-200 focus:border-indigo-500'"
  />

  @if (invalid()) {
    <p class="text-xs font-medium text-red-600" role="alert">{{ errorText() }}</p>
  } @else if (hint()) {
    <p class="text-xs text-slate-500">{{ hint() }}</p>
  }
</div>
